import type React from 'react';

import { Card, CopyButton, Toaster } from '@change/ds-core-ui';
import { CopyIcon } from '@change/ds-icons';

import { useInlineShareCopyCard } from './hooks/useInlineShareCopyCard';

type InlineShareCopyCardProps = {
	buttonConfig: {
		url: string;
		shortUrl?: string;
	};
};

export const InlineShareCopyCard: React.FC<InlineShareCopyCardProps> = ({ buttonConfig: { url, shortUrl } }) => {
	const { data, actions } = useInlineShareCopyCard({ url, shortUrl });

	return (
		<>
			<Toaster />
			<Card elevation className="flex items-center justify-between gap-3 rounded-[12px] bg-white p-4 pl-5">
				<div className="relative min-w-0 flex-1">
					<div className="text-typography-strong text-xs leading-5 font-bold">{data.title}</div>
					<div className="text-typography-weak overflow-hidden text-xs leading-5 text-ellipsis whitespace-nowrap">
						{data.visibleUrl}
					</div>
					<div className="pointer-events-none absolute inset-y-0 right-0 w-8 bg-gradient-to-l from-white to-transparent" />
				</div>
				{/* Overriding the leading icon size as the Button DS component won't let use a number or x-small size */}
				<CopyButton
					buttonLabel={data.buttonLabel}
					toastSuccessLabel={data.toastSuccessLabel}
					toastErrorLabel={data.toastErrorLabel}
					onClick={actions.onCopyClick}
					iconOnly
					aria-label={data.ariaLabel}
					variant="primary"
					size="x-small"
					className="h-11 w-11 p-0"
					leadingIcon={<CopyIcon className="h-5! w-5!" />}
					data-qa="psf-promote-or-share-inline-carousel-copy-button"
				/>
			</Card>
		</>
	);
};
